var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUnion = function SvgIconUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.022 9.731c.432-.219.962-.219 1.393 0l3.938 2c.439.223.71.638.71 1.088v3.931c0 1.572-1.123 2.71-2.182 3.437-1.075.738-2.246 1.169-2.69 1.318a1.5 1.5 0 0 1-.944 0c-.445-.15-1.616-.58-2.69-1.318-1.06-.728-2.182-1.865-2.182-3.437V12.82c0-.45.27-.865.71-1.088zm.697 1.377-3.656 1.856v3.786c0 .881.627 1.63 1.524 2.247.799.548 1.688.902 2.132 1.06.444-.158 1.333-.512 2.131-1.06.897-.616 1.525-1.366 1.525-2.247v-3.786z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M2.719.975C1.63.975.75 1.76.75 2.728v22.043c0 .968.881 1.753 1.969 1.753h18c1.087 0 1.968-.785 1.968-1.753V7.151c0-.465-.207-.911-.576-1.24l-4.966-4.423a2.1 2.1 0 0 0-1.392-.513zm0 1.503c-.156 0-.281.112-.281.25v22.043c0 .138.125.25.28.25h18c.156 0 .282-.112.282-.25V8.489h-4.781c-1.088 0-1.969-.785-1.969-1.753V2.478zm13.219.061v4.197c0 .138.125.25.28.25h4.713l-.013-.012-4.966-4.423z",
    clipRule: "evenodd"
  })));
};
export default SvgIconUnion;